import React from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import PromotionDetailsTable from './PromotionDetailsTable';

const SeasonDiscountsTable = ({ promotionDetails }) => (
    <>
        {promotionDetails?.length ? (
            <>
                <Table>
                    <TableBody>
                        <PromotionDetailsTable promotionDetails={promotionDetails} />
                    </TableBody>
                </Table>
            </>
        ) : null}
    </>
);

SeasonDiscountsTable.propTypes = {
    promotionDetails: PropTypes.array,
};

export default SeasonDiscountsTable;
